import { request } from '@/utils/utils.js'

export default function usePaymentOrderList () {
  const downloadOrdersImpl = that => {
    const url = 'api/dashboard/order/download-by-filter'
    let date_mode = ''
    let zone_id = ''
    that.tzOptions.some((item) => {
      if (item.label == that.currTimeZone) {
        zone_id = item.value
      }
    })
    if (that.value_time) {
      date_mode = Number(that.value_time)
    }
    const data = {
      search_key: that.searchVal,
      search_mode: Number(that.value_mode),
      date_mode,
      zone_id,
      file_type: that.file_type,
      app_id: that.value_app,
      order_currency: that.value_order_currency,
      pay_currency: that.value_pay_currency,
      region: that.value_region,
      method: that.value_method,
      start_time: that.queryDate.start_time,
      end_time: that.queryDate.end_time,
      status: that.value_status
    }
    let access_token = localStorage.getItem('Authorization')
    request({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        access_token
      },
    }).then((res) => {
      if (res.data.code == '10000') {
        that.showToast('Submitted successfully', {
          icon: that.toastIcon,
          position: that.toastPosition,
          duration: that.toastDuration,
          fullWidth: that.isToastFullWidth,
        })
        setTimeout(() => {
          that.$router.push({
            path: 'PaymentOrderDownload',
          })
        }, 2500)
      }
    })
  }

  const formatCurrency = arr =>
    arr.reduce((acc, item) => {
      acc[item.currency] = item.amount
      return acc
    }, {})
  const orderSummaryByFilter = (that, params) => {
    const url = 'api/dashboard/order/summary-by-filter'
    let access_token = localStorage.getItem('Authorization')
    request({
      method: 'post',
      url,
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        access_token
      },
    }).then((res) => {
      if (!res) {
        that.searching.close()
        return
      }
      const { code, data } = res.data
      if (code === '10000') {
        const orderArray = data.filter(item => item.type === 'order')
        const payArray = data.filter(item => item.type === 'pay')
        // 提取所有 currency 并去重
        const allCurrencies = [
          ...new Set([
            ...orderArray.map(i => i.currency),
            ...payArray.map(i => i.currency)
          ])
        ]
        that.tableOrderHeader = ['summary', ...allCurrencies]
        that.tableOrderList = [
          { summary: 'Total Amount', ...formatCurrency(orderArray) },
          // { type: 'Pay', ...formatCurrency(payArray) }
        ]
      }
      setTimeout(() => {
        that.searching.close()
      }, 800)
    }).catch(() => {
      that.searching.close()
    })
  }

  const orderDataImpl = that => {
    const url = 'api/dashboard/order/list-by-filter'
    const params = {
      page_num: that.page,
      page_size: that.limit,
      app_id: that.value_app,
      order_currency: that.value_order_currency,
      pay_currency: that.value_pay_currency,
      region: that.value_region,
      method: that.value_method,
      status: that.value_status,
      start_time: that.queryDate.start_time,
      end_time: that.queryDate.end_time,
      date_mode: that.value_time,
      search_key: that.searchVal,
      search_mode: that.value_mode
    }
    let access_token = localStorage.getItem('Authorization')
    request({
      method: 'post',
      url,
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        access_token
      },
    }).then((res) => {
      if (!res) {
        that.searching.close()
        return
      }
      const { code, data } = res.data
      if (code === '10000') {
        if (data.list.length === 0) {
          that.list = []
          that.total = 0
          that.noData = that.$t('t.noData')
          setTimeout(() => {
            that.searching.close()
          }, 200)
          return
        } else {
          that.list = data.list
          that.total = data.total
        }
        orderSummaryByFilter(that, params)
      }
      setTimeout(() => {
        that.searching.close()
      }, 800)
    }).catch(() => {
      that.searching.close()
    })
  }

  return { downloadOrdersImpl, orderDataImpl }
}
